<script setup lang="ts">
interface Props {
  text: string
  iconClass?: string | null
  layout?: 'horizontal' | 'vertical'
  closedByDefault?: boolean
  bg?: 'dark' | 'light'
}

withDefaults(defineProps<Props>(), {
  layout: 'vertical',
  iconClass: null,
  bg: 'light',
})
</script>

<template>
  <CardComponent
    :bg
    class="p-1 md:p-3"
  >
    <template v-if="$viewport.isLessThan('lg')">
      <PvAccordion :value="closedByDefault ? 'closed' : 'open'">
        <PvAccordionPanel value="open">
          <PvAccordionHeader>
            <TitleComponent
              :text
              :icon-class
              type="subtitle"
            />
          </PvAccordionHeader>
          <PvAccordionContent>
            <div class="flex flex-col gap-2 lg:gap-5 pt-4">
              <slot />
            </div>
          </PvAccordionContent>
        </PvAccordionPanel>
      </PvAccordion>
    </template>
    <template v-else>
      <div class="flex flex-col gap-2 lg:gap-5">
        <TitleComponent
          :text
          :icon-class
          no-caps
          type="subtitle"
        />
        <hr class="col-span-full border-primary-100/20" />
        <slot />
      </div>
    </template>
  </CardComponent>
</template>
